import React from 'react';
import { getSmartSticky } from 'utils';

export default Component => props => (
    <Component {...props} smartSticky={getSmartSticky() || (() => {})} />
);
